<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Expense Items",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect
  },
  data() {
    return {
      match:{
        cat_id:'',
        item_id:''
      },
      title: "Expense Items",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Expense Items",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
         {
          key: "itemName",
          sortable: true,
          label: "ITEM NAME",
        },
        {
          key: "categoryName",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "DATE ADDED",
        },
        
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],
      nameError: "",
      CatError:"",
      // Value from user input for adding category
      data: {
        name: "",
        cat_id:""
      },
      // edit item
      editdata: {
        new_name: "",
        id: "",
        cat_id:""
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("expense", ["ExpenseCategories","Match_Status","ExpenseItems", "ExpenseSaveStatus"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ExpenseItems ? this.ExpenseItems.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ExpenseItems ? this.ExpenseItems.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchExpenseItems: "expense/fetchExpenseItems",
      FetchExpenseCategories: "expense/fetchExpenseCategories",
      MatchExpenseCategory: "expense/matchExpenseCategory",
      AddExpenseItem: "expense/addExpenseItem",
      EditExpenseItem: "expense/editExpenseItem",
      DeleteExpenseItem: "expense/deleteExpenseItem",
    }),
    clearPrevCat(item,model){
      this.match.cat_id = ""
      this.modal_id = model
      this.match.item_id = item.id
    },
    saveMatch(){
  this.MatchExpenseCategory(this.match)
    },    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
   closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingItem = this.ExpenseItems.filter((item) => {
          return item.itemName.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingItem.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    addItem(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Item name field is required";
        return;
      } else {
        this.nameError = "";
      }
         if(this.CatError == ""){
         this.CatError = "Category field is required";
        return;
      } else {
        this.CatError = "";
      }
      if (this.existingItem.length) {
        this.nameError = this.data.name + " exists already please";
        return;
      } else {
        this.nameError = "";
      }

      this.AddExpenseItem(this.data);
    },

    resetAddItem() {
      this.data.name = "";
      this.data.cat_id = "";
      this.nameError = "";
      this.modal_id = "";
    },
    resetEditItem() {
      this.editdata.new_name = "";
      this.editdata.id = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetDeleteItem() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
    },
    showEditModal(data) {
      this.editdata.new_name = data.itemName;
      this.editdata.id = data.id;
      this.editdata.cat_id = data.category_id;
    },
    editExpItem(modalId) {
      this.modal_id = modalId;
      this.EditExpenseItem(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.itemName;
      this.deletedata.id = data.id;
    },
    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteExpenseItem(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchExpenseItems();
    this.FetchExpenseCategories();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div>
                  <b-button v-if="user_permissions.add_expense_category"
                    class="float-end"
                    variant="primary"
                    v-b-modal.add-item-modal
                    ><i class="fa fa-plus"></i>Add Item</b-button
                  >

                  <!-- modal starts -->
                  <b-modal id="add-item-modal" hide-footer @hidden="resetAddItem">
                    <template #modal-title> Add New Expense Item </template>
                    <div class="form-group mb-3">
                      <label>Item Name</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter Category Name"
                          class="form-control"
                          @keyup="checkName"
                          @input="resetError"
                          v-model="data.name"
                        />
                      </div>
                      
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div  class="form-group mb-3">
                        <label>Select Category</label>
                       <model-list-select
                        :list="ExpenseCategories ? ExpenseCategories : []"
                         v-model="data.cat_id"
                        option-value="id"
                        option-text="categoryName"
                        placeholder="Select Expense Category"
                      >
                      </model-list-select>
                       <div class="text-danger" v-if="nameError">
                        <em>{{ CatError }}</em>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-danger"
                        data-dismiss="modal"
                        @click="closeModal('add-item-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addItem('add-item-modal')"
                      >
                        Submit
                        <b-spinner
                          v-if="ExpenseSaveStatus"
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
          
              <b-table
                class="datatables"
                :items="ExpenseItems ? ExpenseItems : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
  <template #cell(categoryName)="data">
    <span class="text-danger" v-if="data.item.categoryName=='not_found'">
      Match category <button @click="clearPrevCat(data.item,'match_cate_model')" v-b-modal.match_cate_model class="btn btn-primary btn-sm">Match <div class="spinner-grow spinner-grow-sm"></div></button>
    </span>
    <span v-else>{{data.item.categoryName}}</span>
  </template>
                <template #cell(actions)="data">
                  <b-button v-if="user_permissions.edit_expense_category"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-item-modal
                    class="m-2"
                    @click="showEditModal(data.item)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button v-else disabled
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-item-modal
                    class="m-2"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button v-if="user_permissions.delete_expense_category"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-category-modal
                    @click="showDeleteModal(data.item)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                  <b-button v-else disabled
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-category-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
              </b-table>
              <center>
                <h3 v-if="!ExpenseItems" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- edit modal starts -->
            <b-modal id="edit-item-modal" hide-footer @hidden="resetEditItem">
              <template #modal-title> Edit Category {{ editdata.new_name }}</template>
              <div class="form-group mb-3">
                <label>Category Name</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    @input="resetError"
                    v-model="editdata.new_name"
                  />
                </div>
                <div class="text-danger" v-if="nameError">
                  <em>{{ nameError }}</em>
                </div>
              </div>
                <div  class="form-group mb-3">
                        <label>Select Category</label>
                       <model-list-select
                        :list="ExpenseCategories ? ExpenseCategories : []"
                         v-model="editdata.cat_id"
                        option-value="id"
                        option-text="categoryName"
                        placeholder="Select Expense Category"
                      >
                      </model-list-select>
                       <div class="text-danger" v-if="nameError">
                        <em>{{ CatError }}</em>
                      </div>
                    </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-item-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editExpItem('edit-item-modal')"
                >
                  Save Changes
                  <b-spinner
                    v-if="ExpenseSaveStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete category starts -->
            <b-modal
              header-bg-variant="danger"
              header-text-variant="light"
              body-text-variant="danger"
              footer-bg-variant="danger"
              footer-text-variant="danger"
              id="delete-category-modal"
              hide-footer
              @hidden="resetDeleteItem"
            >
              <template #modal-title> Delete Category {{ deletedata.name }}</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this category? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-category-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteItem('delete-category-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="ExpenseSaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->


<!-- START MATCH CATEGORY MODEAL -->
  <b-modal id="match_cate_model" hide-footer="true" title="Match Category">
  <label>Select Expense Category</label>
                       <model-list-select
                        :list="ExpenseCategories ? ExpenseCategories : []"
                        v-model="match.cat_id"
                        option-value="id"
                        option-text="categoryName"
                        placeholder="Select Expense Category"
                      >
                      </model-list-select>
       <div class="modal-footer">
        <button @click="closeMode('match_cate_model')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button @click="saveMatch()" type="button" class="btn btn-primary">Save changes  <b-spinner
                    v-if="Match_Status"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner></button>
      </div>
  </b-modal>
<!-- END MACTH CATEGORY MODEAL -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
